import { token } from '@atlaskit/tokens';
import { AtlassianIcon } from '@atlaskit/logo';
import Tile from '@atlaskit/tile';
import Avatar from '@atlaskit/avatar';
import { useUser } from '#definitions/user';
import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import type { FunctionComponent } from 'react';

const styles = cssMap({
  avatarStyle: {
    alignSelf: 'flex-start',
    marginLeft: token('space.negative.150'),
    marginTop: token('space.negative.150'),
  },
  iconStyle: {
    padding: token('space.100'),
  },
});

const AtlassianUserIcon: FunctionComponent = () => {
  const user = useUser();
  return (
    <Inline alignInline={'center'}>
      <Tile
        label="Atlassian"
        size="xlarge"
        backgroundColor="color.background.brand.bold"
        isInset={false}
      >
        <Box xcss={styles.iconStyle}>
          <AtlassianIcon size="xlarge" appearance="inverse" />
        </Box>
      </Tile>
      <Avatar
        size="small"
        src={user?.picture}
        // apply styling to put the avatar in the top-right corner
        as={({ children, ...props }) => (
          <div css={styles.avatarStyle} {...props}>
            {children}
          </div>
        )}
      />
    </Inline>
  );
};

export default AtlassianUserIcon;
